import React, { useState, useEffect } from 'react'
import { withStyles, Typography } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import styles from './style'
import { userGetSelfAction } from 'src/reducers/user/action'
import { useDispatch, useSelector } from 'react-redux'
import Lottie from 'react-lottie'
//import animationData from 'src/lotties/AI-ready-v2-mobile_small.json'
import { track } from '@amplitude/analytics-browser'
import { CoreButton } from 'src/components/core'
import { useCoursePreviewUrl } from 'src/hooks/useCoursePreviewUrl'
import animationDataMobile2 from 'src/lotties/mcg-v4-mobile-desktop.json'

const MobileUi = props => {
  const { classes } = props
  let history = useHistory()
  const [collection] = useState(
    window.location.pathname.split('create-course/')[1] || '',
  )
  const courseData = useSelector(state => state.course.course)
  const previewUrl = useCoursePreviewUrl(courseData)
  const dispatch = useDispatch()

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationDataMobile2,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  useEffect(() => {
    dispatch(userGetSelfAction())
  }, [dispatch])

  const handleClickCard = index => {
    if (index == 0) {
      history.push('/ai-course-creation?collectionId=' + collection)
      track('mobile_ai_selected', {})
      return
    }
    return true
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        minHeight: '100vh',
      }}
    >
      <Typography fontSize={24} fontWeight={600} textAlign={'center'}>
        Hi, {window.CONSTANTS.NAME}👋
      </Typography>

      <div
        style={{
          borderRadius: '16px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '24px',
        }}
      >
        <Typography fontSize={16} fontWeight={400} textAlign={'center'}>
          Creating, editing, and managing courses are optimized for desktop
          browsers. Please visit your account{' '}
          <span style={{ color: '#015FFB' }}>on desktop</span> for the full
          capability.
        </Typography>

        <Lottie options={defaultOptions} height={182} width={300} />
      </div>

      <div
        style={{
          borderRadius: '16px',
          padding: '20px',
          gap: '24px',
          backgroundColor: '#FFFFFF',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow:
            '0 0 2px 0 rgba(145, 158, 171, 0.12), 0 12px 24px -4px rgba(145, 158, 171, 0.12);',
        }}
      >
        <Typography
          fontSize={18}
          fontWeight={500}
          textAlign={'center'}
          color={'#015FFB'}
        >
          View your course
        </Typography>

        <Typography fontSize={16} fontWeight={400} textAlign={'center'}>
          Editing is available on desktop, but you can preview your course here.
        </Typography>
        <CoreButton
          variant="contained"
          size="large"
          href={previewUrl}
          target="_blank"
        >
          Preview Course
        </CoreButton>
      </div>
    </div>
  )
}

export default withStyles(styles)(MobileUi)
